import React from "react";

// User-provided brand icon (gorilla/yellow badge).
const IMG_URL = "https://customer-assets.emergentagent.com/job_merchant-hub-439/artifacts/blvfnodd_1f4e0838-a3b7-466f-b203-2000c6791b3f-200x.avif";

export default function BrandLogo({ size = 36, className = "" }) {
  return (
    <img
      src={IMG_URL}
      alt="BeforeTheDeadline"
      style={{ width: size, height: size }}
      className={`rounded-md object-contain bg-[#FFD60A] p-0.5 ${className}`}
      data-testid="brand-logo"
    />
  );
}
